'use strict';

/* Controllers */

app.controller('DrinkOptionsController', ['$scope', '$rootScope', 'Drink', 'Helper', 
    function ($scope, $rootScope, Drink, Helper) {

    	// init scope vars
    	var currency_symbol = $rootScope.globals.selectedVenue.currency_symbol+' ';
    	var drink_price = Drink.getSelectedDrinkPrice();

    	$scope.drink_options = [
    		{
    			name: 'Double (+'+currency_symbol+drink_price+')',
    			checked: false,
                enabled: true,
    		},
    		{
    			name: 'On the rocks',
    			checked: false,
                enabled: true,
    		},
    		{
    			name: 'Tall glass',
    			checked: false,
                enabled: true,
    		},
    		{
    			name: 'Mixer on the side',
    			checked: false,
                enabled: false,
    		}
    	];

    	$scope.mixers = [
    				'Mixers', 'Coke', 'Cranberry', 'Cranberry and Soda', 'Diet Coke', 'Dr. Pepper', 'Ginger Ale', 
    				'Green Tea', 'Orange Fanta', 'Orange Juice', 'Red Bull', 'Soda', 'Sprite', 'Tonic', 'Water'
    			];

    	$scope.selected_mixer = 'Mixers';


    	/**
    	 * add selected drink option
    	 * 
    	 * @param Object  drink_option
    	 */
    	$scope.addDrinkOption = function(drink_option){

            if( drink_option.enabled ){
        		drink_option.checked = !drink_option.checked;
            }

    	}


        /**
         * watch if selected_mixer is changed
         * if it is than enable selection of
         * mixer on the side
         */
        $scope.$watch('selected_mixer', function() {
            console.log($scope.selected_mixer);
            if( $scope.selected_mixer == 'Mixers' ){
                $scope.drink_options[3].checked = false;
                $scope.drink_options[3].enabled = false;
            }
            else{
                $scope.drink_options[3].enabled = true;
            }
        });


    	/**
    	 * called wehn submit button is clicked
    	 * in the drink option popup
    	 */
    	$scope.submitDrinkOptions = function(){
    		var selected_drink_options = { mixer: '', options: [] };

    		// prepare selected_drink_options array
    		angular.forEach($scope.drink_options, function(drink_option) {
    			if( drink_option.checked ){
	    			selected_drink_options.options.push( drink_option.name );
    			}
    		});

    		// add mixer if it was selected
    		if( $scope.selected_mixer !== null && $scope.selected_mixer !== 'Mixer' ) selected_drink_options.mixer = $scope.selected_mixer;
    		
    		// add selection to root scope
    		$rootScope.globals.selectedDrink.drinkOptions = selected_drink_options;

            // redirect
            $scope.closeThisDialog('submited');
    	}

    }]);
